<template>
  <div class="archiveMamage">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="附件管理" name="first">
          <span class="activeLink">附件管理</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong"
                  class="cleanBox" size="small" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">查询</el-button>
            </div>
            <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="addNewBtn">新建</el-button> -->
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch"
      >
        <div class="searchConditionBox">
          <el-form-item label="请求ID" size="small">
            <el-input
              :value="searchConditionForm.requestId"
              @input="idInputChange($event, 'searchConditionForm')"
              placeholder="Request ID"
              clearable
              @keyup.enter.native="getArchiveSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="文件名" size="small">
            <el-input
              v-model="searchConditionForm.fileName"
              placeholder="文件名"
              clearable
              @keyup.enter.native="getArchiveSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'user', '员工选择', 'searchConditionForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="rightContent">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
        >
          <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80:50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="id"
            label="Request ID"
            min-width="90px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{scope.row.id}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="文件名"
            min-width="110px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="allowSkip" v-if="scope.row.name" @click="downloadFile(scope.row)">{{scope.row.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="contentType"
            label="类型"
            min-width="90px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.contentType">{{scope.row.contentType}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="size"
            label="大小(字节)"
            align="center"
            max-width="180px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.size">{{scope.row.size}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="source"
            label="来源"
            align="center"
            max-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{scope.row.source == 1 ? '用户上传' : '系统生成'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="uploader"
            label="创建人"
            align="center"
            max-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.uploader">{{scope.row.uploader.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="uploadDateTime"
            label="创建时间"
            min-width="90px"
            max-width="180px"
            align="center"
            show-overflow-tooltip
            sortable="uploadDateTime"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.uploadDateTime">{{scope.row.uploadDateTime}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getArchiveSearch"
        ></pagination>
      </div>
    </div>
    <orderTableSelect ref="orderTableSelect" @orderTableSubmit="orderTableSubmit"></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import { apiArchiveSearch } from "@/api/archiveMamage.js";
import { apiDownloadFile } from "@/api/filesUpload.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/archiveMamage" },
  components: {
    pagination,
    orderTableSelect
  },
  data() {
    return {
      isMoreSearch: false,
      searchConditionForm: {},
      pullDownData: {
        userList: []
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
    };
  },
  methods: {
    // 表格数据
    async getArchiveSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiArchiveSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {
      this.searchConditionForm = {};
      this.getArchiveSearch();
    },
    // 确认查询
    onSearch() {
      this.pagination.currentPage = 1;
      this.getArchiveSearch();
    },
    // 文件下载
    downloadFile(row) {
      let url = apiDownloadFile(row.id, row.secret);
      let a = document.createElement("a");
      a.href = url;
      a.style.display = "none";
      a.target = "_blank"
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 判断id只能输入数字
    idInputChange(value, formName) {
      this.$set(this[formName], "requestId", this.$formatPositive(value));
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    // 查询条件-发布开始时间
    startDateChange() {
      let { startDateTime, endDateTime } = this.searchConditionForm;
      if (startDateTime > endDateTime) {
        this.searchConditionForm.endDateTime = this.searchConditionForm.startDateTime;
      }
    },
    // 查询条件-发布结束时间
    endDateChange() {
      let { startDateTime, endDateTime } = this.searchConditionForm;
      if (startDateTime > endDateTime) {
        this.searchConditionForm.startDateTime = this.searchConditionForm.endDateTime;
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getArchiveSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getArchiveSearch();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getArchiveSearch();
    },
    callback() {}
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    this.getArchiveSearch("", this.callback);
  },
  deactivated() {
    window.onresize = null;
  }
};
</script>

<style lang="less" scoped>
</style>